module.exports = __webpack_public_path__ + "static/img/logo2.614102b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo2.jpg
// module id = MqoH
// module chunks = 1